// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { headset16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-headset': IconHeadset;
    }
}

/**
 * The icon component for the 'headset' icon
 */
export class IconHeadset extends IconSvg {
    public constructor() {
        super(headset16X16);
    }
}

registerIconSvg('icon-headset', IconHeadset);
export const iconHeadsetTag = 'nimble-icon-headset';
